// components/AssetClientLogo/AssetClientLogo.tsx
import React from 'react';
import Link from 'next/link';
import parse from 'html-react-parser';
import classNames from 'classnames';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
import { orgPath } from '@/libs/orgPath/orgPath';
import { sanitizeTitle } from '@/libs/sanitizeTitle/sanitizeTitle';
import ClientLogoRendering from '@/components/ClientLogo/ClientLogoRendering';
interface AssetClientLogoProps {
  customTemplate: boolean;
  resourceData: any;
  responseData: any;
  showLogo1: boolean;
  setShowLogo1: React.Dispatch<React.SetStateAction<boolean>>;
  titleLineBreakClass: boolean | string;
  setTitleLineBreakClass: React.Dispatch<React.SetStateAction<boolean>>;
  params: any;
  pathname: string;
  queryParams: string;
  t: any;
}
const AssetClientLogo: React.FC<AssetClientLogoProps> = ({
  customTemplate,
  resourceData,
  responseData,
  showLogo1,
  setShowLogo1,
  titleLineBreakClass,
  setTitleLineBreakClass,
  params,
  pathname,
  queryParams,
  t
}) => {
  return <div className={'client-logo ' + titleLineBreakClass} data-sentry-component="AssetClientLogo" data-sentry-source-file="AssetClientLogo.tsx">
   <ClientLogoRendering customTemplate={customTemplate} hasOrgCustomBanner={resourceData?.hasOrgCustomBanner} orgImages={resourceData?.orgImages} orgId={responseData.orgId} showLogo1={showLogo1} setShowLogo1={setShowLogo1} setTitleLineBreakClass={setTitleLineBreakClass} lang={params.lang} pathname={pathname} queryParams={queryParams} peId={params.peId} data-sentry-element="ClientLogoRendering" data-sentry-source-file="AssetClientLogo.tsx" />

   <span className={classNames(['client-name', customTemplate ? 'custom-client-name' : ''])}>
    <span>{t('By')} </span>
    <Link onClick={() => pushGTMClickTags({
        click_element: 'Anchor',
        click_closest_class: 'NONE',
        click_section_ID: 'NONE',
        link_classes: 'org-name',
        link_id: 'NONE',
        link_text: responseData.orgName,
        link_url: `/hub/${responseData.orgId}`,
        click_category: 'NONE',
        click_destination: 'org page',
        click_closest_href: 'NONE'
      })} href={orgPath({
        orgId: responseData.orgId,
        locale: params.lang,
        c: pathname.includes('/c/'),
        peId: params.peId
      }) + queryParams} className={'org-name'} data-sentry-element="Link" data-sentry-source-file="AssetClientLogo.tsx">
     <span className={'the-client'}>
      {parse(sanitizeTitle(responseData.orgName))}
     </span>
    </Link>
   </span>
  </div>;
};
export default AssetClientLogo;